import firebase from 'firebase';

const state = {
  user: {   
    login_count: 0,
    email: null, 
    display_name: null, 
    first_name: null,
    last_name: null, 
    email_verified: false,
    registration_method: "admin",
    created_by: null,
    role: "user", 
    dashboard_settings: {}
  },
  organisation: {   
    created_by: null,
    name: "", 
  },
  subscriptions: []

};

const actions = {
  newUser({dispatch}, user ){
    return new Promise((resolve, reject) => {
      dispatch("addDoc", {collection: "users", data: user }).then(( ref ) => {
        var functions = firebase.app().functions('europe-west1');
        var createAuthUser = functions.httpsCallable('createAuthUser');
        createAuthUser(ref.id).then( () => {
          resolve(ref.id);
        }).catch((error) => {
          reject(error)
        })
      })
    });
  },
  newOrganisation({dispatch}, organisation ){
    return new Promise((resolve, reject) => {
      dispatch("addDoc", {collection: "users", data: organisation }).then(( ref ) => {
        resolve(ref.id);
      }).catch((error) => {
        reject(error)
      })
    });
  }
} 

const mutations = {
}

const getters = {
  getEmptyUser(state){
    var user = {...state.user}
    user.created_by = firebase.auth().currentUser.uid;
    return user;
  },
  getOrganisation(state){
    var organisation = {...state.organisation}
    organisation.created_by = firebase.auth().currentUser.uid;
    return organisation;
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
